import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
  } from 'recharts';
import { Card, CardContent } from "../../../components/ui/card";
import constants from '../../../commonUtils/constants';


const MasterProjectUploads = ({ data }) => {
    return (
        <>
            <Card className="shadow-md rounded-2xl col-span-1 md:col-span-1 lg:col-span-1">
                <CardContent>
                    <h2 className="text-lg font-bold mb-4">Master Project Upload Volume</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="project" />
                            <YAxis allowDecimals={false} />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="count" name="Master Project Count" fill={constants.dashboard.colors[1]} radius={[4, 4, 0, 0]} />
                        </BarChart>
                    </ResponsiveContainer>
                </CardContent>
            </Card>
        </>
    );
};

export default MasterProjectUploads;
